import React, {Component} from 'react';
import {Checkbox, Col, ControlLabel, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import {TopAlertInformacja, TopAlertOstrzezenie} from "../../../../componentsTopsa/alerty/TopAlerts";
import Dropzone from "react-dropzone";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import moment from 'moment'
import PlikiService from "../../PlikiService";
import Validator from "../../../../utilities/Validator";

export default class KlienciForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            imie: '',
            nazwisko: '',
            miejscowosc: '',
            dataUrodzenia: null,
            kodPoczt: '',
            nrDok: '',
            nrDomu: '',
            nrMieszk: '',
            nrTel: '',
            ulica: '',
            //  pesel: '',
            zdjecie: '',
            wygraneZdjecie: null,
            validatorMessages: [],
            nrDokWaznyDo: null,
            nrDokCzySprawdzony: false,
            nrDokSkan: '',
            nrDokSkanEdytowany: null,
            tablicaSkanowDodanych: [],
            tablicaSkanowDoWysylki: [],
            //  czyPoprawnyPesel: false,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeEmail = this.onChangeEmail.bind(this)
        this.onChangeImie = this.onChangeImie.bind(this)
        this.onChangeNazwisko = this.onChangeNazwisko.bind(this)
        this.onChangeMiejscowosc = this.onChangeMiejscowosc.bind(this)
        this.onChangeKodPocztowy = this.onChangeKodPocztowy.bind(this)
        this.onChangeNrDok = this.onChangeNrDok.bind(this)
        this.onChangeDokumentWaznyDo = this.onChangeDokumentWaznyDo.bind(this)
        this.onChangeDataUrodzenia = this.onChangeDataUrodzenia.bind(this)
        this.onChangeNrDomu = this.onChangeNrDomu.bind(this)
        this.onChangeNrMieszk = this.onChangeNrMieszk.bind(this)
        this.onChangeTelefon = this.onChangeTelefon.bind(this)
        this.onChangeUlica = this.onChangeUlica.bind(this)
        //   this.onChangePesel = this.onChangePesel.bind(this)
        this.onDrop = this.onDrop.bind(this)
        this.onDropSkan = this.onDropSkan.bind(this)
    }

    componentDidMount() {
        if (this.props.edytowany) {
            this.setState({
                email: Boolean(this.props.edytowany.email) ? this.props.edytowany.email : '',
                imie: Boolean(this.props.edytowany.imie) ? this.props.edytowany.imie : '',
                nazwisko: Boolean(this.props.edytowany.nazwisko) ? this.props.edytowany.nazwisko : '',
                miejscowosc: Boolean(this.props.edytowany.miejscowosc) ? this.props.edytowany.miejscowosc : '',
                kodPoczt: Boolean(this.props.edytowany.kodPoczt) ? this.props.edytowany.kodPoczt : '',
                nrDok: Boolean(this.props.edytowany.nrDok) ? this.props.edytowany.nrDok : '',
                nrDomu: Boolean(this.props.edytowany.nrDomu) ? this.props.edytowany.nrDomu : '',
                nrMieszk: Boolean(this.props.edytowany.nrMieszk) ? this.props.edytowany.nrMieszk : '',
                nrTel: Boolean(this.props.edytowany.nrTel) ? this.props.edytowany.nrTel : '',
                ulica: Boolean(this.props.edytowany.ulica) ? this.props.edytowany.ulica : '',
                dataUrodzenia: Boolean(this.props.edytowany.dataUrodzenia) ? moment(this.props.edytowany.dataUrodzenia) : null,
                // pesel: Boolean(this.props.edytowany.pesel)? this.props.edytowany.pesel : '',
                tablicaSkanowDodanych: this.props.edytowany.zdjeciaSkany,
                wygraneZdjecie: Boolean(this.props.edytowany.zdjecieProfilowe) ? this.props.edytowany.zdjecieProfilowe : null,
                nrDokCzySprawdzony: this.props.edytowany.nrDokSprawdzony,
                nrDokWaznyDo: Boolean(this.props.edytowany.nrDokWaznyDo) ? moment(this.props.edytowany.nrDokWaznyDo) : null,
                //  czyPoprawnyPesel: Boolean(this.props.edytowany.pesel)? this.validatePesel(this.props.edytowany.pesel) : false
            })

            document.getElementById('inputImie').value = this.props.edytowany.imie
            document.getElementById('inputNazwisko').value = this.props.edytowany.nazwisko
            document.getElementById('inputDokument').value = this.props.edytowany.nrDok
            document.getElementById('inputTelefon').value = this.props.edytowany.nrTel
            document.getElementById('inputEmail').value = this.props.edytowany.email
            document.getElementById('inputMiejscowosc').value = this.props.edytowany.miejscowosc
            document.getElementById('inputKodPoczt').value = this.props.edytowany.kodPoczt
            document.getElementById('inputUlica').value = this.props.edytowany.ulica
            document.getElementById('inputDom').value = this.props.edytowany.nrDomu
            document.getElementById('inputMieszkanie').value = this.props.edytowany.nrMieszk
            //  document.getElementById('inputPesel').value = this.props.edytowany.pesel

            this.polaczDokumentySkanyIZdjeciaWWiokuKlienta(this.props)
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.edytowany) {
            this.setState({
                email: Boolean(nextprops.edytowany.email) ? nextprops.edytowany.email : '',
                imie: Boolean(nextprops.edytowany.imie) ? nextprops.edytowany.imie : '',
                nazwisko: Boolean(nextprops.edytowany.nazwisko) ? nextprops.edytowany.nazwisko : '',
                miejscowosc: Boolean(nextprops.edytowany.miejscowosc) ? nextprops.edytowany.miejscowosc : '',
                kodPoczt: Boolean(nextprops.edytowany.kodPoczt) ? nextprops.edytowany.kodPoczt : '',
                nrDok: Boolean(nextprops.edytowany.nrDok) ? nextprops.edytowany.nrDok : '',
                nrDomu: Boolean(nextprops.edytowany.nrDomu) ? nextprops.edytowany.nrDomu : '',
                nrMieszk: Boolean(nextprops.edytowany.nrMieszk) ? nextprops.edytowany.nrMieszk : '',
                nrTel: Boolean(nextprops.edytowany.nrTel) ? nextprops.edytowany.nrTel : '',
                ulica: Boolean(nextprops.edytowany.ulica) ? nextprops.edytowany.ulica : '',
                dataUrodzenia: Boolean(nextprops.edytowany.dataUrodzenia) ? moment(nextprops.edytowany.dataUrodzenia) : null,
                // pesel: Boolean(nextprops.edytowany.pesel)? nextprops.edytowany.pesel : '',
                tablicaSkanowDodanych: nextprops.edytowany.zdjeciaSkany,
                wygraneZdjecie: Boolean(nextprops.edytowany.zdjecieProfilowe) ? nextprops.edytowany.zdjecieProfilowe : null,
                nrDokCzySprawdzony: nextprops.edytowany.nrDokSprawdzony,
                nrDokWaznyDo: Boolean(nextprops.edytowany.nrDokWaznyDo) ? moment(nextprops.edytowany.nrDokWaznyDo) : null,
                //  czyPoprawnyPesel: Boolean(nextprops.edytowany.pesel)? this.validatePesel(nextprops.edytowany.pesel) : false

            })

            document.getElementById('inputImie').value = nextprops.edytowany.imie
            document.getElementById('inputNazwisko').value = nextprops.edytowany.nazwisko
            document.getElementById('inputDokument').value = nextprops.edytowany.nrDok
            document.getElementById('inputTelefon').value = nextprops.edytowany.nrTel
            document.getElementById('inputEmail').value = nextprops.edytowany.email
            document.getElementById('inputMiejscowosc').value = nextprops.edytowany.miejscowosc
            document.getElementById('inputKodPoczt').value = nextprops.edytowany.kodPoczt
            document.getElementById('inputUlica').value = nextprops.edytowany.ulica
            document.getElementById('inputDom').value = nextprops.edytowany.nrDomu
            document.getElementById('inputMieszkanie').value = nextprops.edytowany.nrMieszk
            //   document.getElementById('inputPesel').value = nextprops.edytowany.pesel

            this.polaczDokumentySkanyIZdjeciaWWiokuKlienta(nextprops)
        }
    }

    polaczDokumentySkanyIZdjeciaWWiokuKlienta(props) {
        if (props.edycjaNaStronieKlienta) {
            this.setState({tablicaSkanowDodanych: props.edytowany.zdjeciaSkany.concat(props.edytowany.dokumentySkany)})
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {


        let arrayPliki = []

        if (this.state.tablicaSkanowDoWysylki.length > 0) {
            for (let i = 0; i < this.state.tablicaSkanowDoWysylki.length; i++) {
                arrayPliki.push(this.state.tablicaSkanowDoWysylki[i])
            }
        }

        if (Boolean(this.state.zdjecie)) {
            arrayPliki.push(this.state.zdjecie)
        }


        this.setState({validatorMessages: []})
        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.imie)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono pola imie')
        }

        if (!Boolean(this.state.nazwisko)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono pola nazwisko')
        }

        /*if(Boolean(this.state.pesel)){
            if (!Boolean(this.state.czyPoprawnyPesel)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Podany PESEL jest niepoprawny. Jeśli nie jest wiadomy poprawny PESEL, proszę wyczyścić pole.')
            }
        }*/

        if (poprawne) {

            this.state.validatorMessages = [];
            this.setState({czyBylPrzycisk: false, validatorMessages: []})


            let data = {
                "email": this.state.email,
                "idKl": Boolean(this.props.edytowany) ? this.props.edytowany.idKl : null,
                "imie": this.state.imie,
                "kodPoczt": this.state.kodPoczt,
                "miejscowosc": this.state.miejscowosc,
                "nazwisko": this.state.nazwisko,
                "nrDok": this.state.nrDok,
                "nrDomu": this.state.nrDomu,
                "nrMieszk": this.state.nrMieszk,
                "dataUrodzenia": this.state.dataUrodzenia,
                "nrTel": this.state.nrTel,
                "ulica": this.state.ulica,
                //   "pesel": this.state.pesel,
                "plikiRequest": arrayPliki,
                "nrDokSprawdzony": this.state.nrDokCzySprawdzony,
                "nrDokWaznyDo": Boolean(this.state.nrDokWaznyDo) ? DateAndTimeFormat.formatYYYYMMDD(this.state.nrDokWaznyDo) : null
            }


            this.props.handleClickZapisz(data, Boolean(this.props.edytowany))
        }
    }

    onChangeImie(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 25, 'inputImie', this.state.imie))
            this.setState({imie: e.target.value})
    }

    onChangeNazwisko(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 35, 'inputNazwisko', this.state.nazwisko))
            this.setState({nazwisko: e.target.value})
    }

    onChangeNrDok(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 20, 'inputDokument', this.state.nrDok))
            this.setState({nrDok: e.target.value})
    }

    onChangeDokumentWaznyDo(e) {
        this.setState({nrDokWaznyDo: e})
    }

    onChangeTelefon(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 15, 'inputTelefon', this.state.nrTel))
            this.setState({nrTel: e.target.value})
    }

    onChangeEmail(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 200, 'inputEmail', this.state.email))
            this.setState({email: e.target.value})
    }

    onChangeMiejscowosc(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 30, 'inputMiejscowosc', this.state.miejscowosc))
            this.setState({miejscowosc: e.target.value})
    }

    onChangeKodPocztowy(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 10, 'inputKodPoczt', this.state.kodPoczt))
            this.setState({kodPoczt: e.target.value})
    }

    onChangeUlica(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 40, 'inputUlica', this.state.ulica))
            this.setState({ulica: e.target.value})
    }

    onChangeNrDomu(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 10, 'inputDom', this.state.nrDomu))
            this.setState({nrDomu: e.target.value})
    }

    onChangeNrMieszk(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 10, 'inputMieszkanie', this.state.nrMieszk))
            this.setState({nrMieszk: e.target.value})
    }

    onChangeDataUrodzenia(e) {
        this.setState({dataUrodzenia: e})
    }

    /*onChangePesel(e) {
        if (e.target.value.length <= 11) {
            this.setState({pesel: e.target.value, czyPoprawnyPesel: this.validatePesel(e.target.value)})
        }
        else {
            document.getElementById('inputPesel').value = this.state.pesel
        }
    }*/

    onDrop(obj) {

        if (obj !== null) {
            if (obj[0].type !== 'image/jpg' && obj[0].type !== 'image/jpeg') {
                alert('Można załączyć tylko pliki graficzne o formacie JPG lub JPEG')
            } else {
                if (obj[0].size > 3072000) {
                    alert('Rozmiar pliku jest za duży! Max 3MB')
                } else {
                    this.setState({
                        //    zdjecie: obj[0],
                        wygraneZdjecie: null
                    })


                    const promise = new Promise((resolve, reject) => {
                        const reader = new FileReader()

                        reader.readAsDataURL(obj[0])

                        reader.onload = () => {
                            if (!!reader.result) {
                                resolve(reader.result)
                            } else {
                                reject(Error("Failed converting to base64"))
                            }
                        }

                    })
                    promise.then(result => {
                        // dispatch or do whatever you need with result

                        let przecinek = result.indexOf(',');
                        let skrocony = result.substr(przecinek + 1, result.length - 1)

                        this.setState({
                            zdjecie:
                                {
                                    "dane": skrocony,
                                    "nazwa": obj[0].name,
                                    "typ": obj[0].type,
                                    "rozmiar": obj[0].size,
                                    "dokumentTyp": "KLIENT_ZDJECIE"
                                }
                        })


                    }, err => {
                        console.log(err)
                        alert('Błąd przy próbie załadowania grafiki')
                    })


                }
            }
        }
    }

    onDropSkan(obj) {

        for (let i = 0; i < obj.length; i++) {

            if (obj[i] !== null) {
                if (obj[i].size > 4096000) {
                    alert('Rozmiar pliku jest za duży! Max 4MB')
                } else {

                    const promise = new Promise((resolve, reject) => {
                        const reader = new FileReader()

                        reader.readAsDataURL(obj[i])

                        reader.onload = () => {
                            if (!!reader.result) {
                                resolve(reader.result)
                            } else {
                                reject(Error("Failed converting to base64"))
                            }
                        }

                    })
                    promise.then(result => {
                        // dispatch or do whatever you need with result

                        let przecinek = result.indexOf(',');
                        let skrocony = result.substr(przecinek + 1, result.length - 1)

                        let arr = this.state.tablicaSkanowDoWysylki
                        arr.push({
                            "localid": (new Date().toISOString()) + (Math.floor(Math.random() * 1000 + 1)),
                            "dane": skrocony,
                            "nazwa": obj[i].name,
                            "typ": obj[i].type,
                            "rozmiar": obj[i].size,
                            "dokumentTyp": "KLIENT_DOK_SKAN"
                        })
                        this.setState({tablicaSkanowDoWysylki: arr})


                    }, err => {
                        console.log(err)
                        alert('Błąd przy próbie załadowania grafiki')
                    })


                }

            }
        }

    }

    onClickUsunSkanyZWysylki(id) {
        let array = this.state.tablicaSkanowDoWysylki
        array.splice(array.findIndex(i => i.localid == id), 1);
        this.setState({tablicaSkanowDoWysylki: array})
    }

    onClickUsunSkanZSerwera(obj) {
        PlikiService.deletePlik(obj.id).then(function (response) {
            let array = this.state.tablicaSkanowDodanych
            array.splice(array.findIndex(i => i.id == obj.id), 1);
            this.setState({tablicaSkanowDodanych: array})
        }.bind(this))
    }

    usunZdjecieProfilowe() {
        PlikiService.deletePlik(this.state.wygraneZdjecie.id).then(function (response) {
            console.log('usunieto zdjecie profilowe')
            this.setState({
                wygraneZdjecie: null
            })
        }.bind(this))
    }


    /* validatePesel(pesel) {
         let reg = /^[0-9]{11}$/;
         if (reg.test(pesel) === false) {
             return false;
         }
         else {
             let dig = ("" + pesel).split("");
             let kontrola = (1 * parseInt(dig[0]) + 3 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 9 * parseInt(dig[3]) + 1 * parseInt(dig[4]) + 3 * parseInt(dig[5]) + 7 * parseInt(dig[6]) + 9 * parseInt(dig[7]) + 1 * parseInt(dig[8]) + 3 * parseInt(dig[9])) % 10;
             if (kontrola === 0) kontrola = 10;
             kontrola = 10 - kontrola;
             return parseInt(dig[10]) === kontrola;
         }

     }*/


    render() {

        return (
            <div>
                <fieldset>
                    <div
                        className={'fieldset-label'}>{Boolean(this.props.edytowany) ? 'Edycja klienta' : 'Nowy klient'}</div>
                    <Form horizontal={true} className={'horizontal-form'}>
                        <Row>
                            <Col xs={12} lg={6}>
                                <FormGroup>
                                    <h6>Dane osobowe</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Imię <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.imie.length}/25 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputImie'} onChange={this.onChangeImie}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Nazwisko <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nazwisko.length}/35 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputNazwisko'} onChange={this.onChangeNazwisko}/>
                                    </Col>
                                    {/*<Col xs={12}>
                                        <ControlLabel>
                                            Pesel <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.pesel.length}/11 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputPesel'} onChange={this.onChangePesel}/>
                                    </Col>
                                    <Col xs={12}>
                                        <div style={{marginLeft: '250px'}}>
                                            {
                                                Boolean(this.state.pesel) ?
                                                    (this.state.pesel.length > 0 && !this.state.czyPoprawnyPesel) ?
                                                        <TopAlertOstrzezenie text={'Wprowadzony numer PESEL jest niepoprawny'}/>
                                                        :
                                                        ''
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </Col>*/}
                                </FormGroup>
                                <FormGroup>
                                    <h6>Dokument uprawniający do ulgi</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Nr dokumentu <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nrDok.length}/20 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputDokument'} onChange={this.onChangeNrDok}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Ważny do
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDokumentWaznyDo}
                                                      value={this.state.nrDokWaznyDo} horizontal={false}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Data urodzenia
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDataUrodzenia}
                                                      value={this.state.dataUrodzenia} horizontal={false}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>Czy sprawdzony</ControlLabel>
                                        <Checkbox inline={true} checked={this.state.nrDokCzySprawdzony}
                                                  style={{textAlign: 'left'}}
                                                  onClick={() => {
                                                      this.setState({nrDokCzySprawdzony: !this.state.nrDokCzySprawdzony})
                                                  }}
                                        >
                                            {Boolean(this.state.nrDokCzySprawdzony) ? 'tak' : 'nie'}
                                        </Checkbox>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Skan dokumentu
                                        </ControlLabel>
                                        <section className={'dropzoneSection'} style={{display: 'inline-block'}}>
                                            <div className="dropzone" style={{
                                                border: '1px dotted #aaa',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                lineHeight: '34px',
                                                padding: '0 10px'
                                            }}>
                                                <Dropzone onDrop={this.onDropSkan} style={{}} multiple={true}>
                                                    <span style={{display: 'inline-block'}}>
                                                        {
                                                            Boolean(this.state.tablicaSkanowDoWysylki.length > 0) ?
                                                                <span style={{color: 'dodgerblue'}}>
                                                                    <i className={'fa fa-info-circle'}></i> Wybierz ponownie aby dodać kolejne pliki
                                                                </span>
                                                                :
                                                                <span style={{color: 'dodgerblue'}}>
                                                                    <i className={'fa fa-info-circle'}></i> Przeciągnij wiele plików lub kliknij by wybrać
                                                                </span>

                                                        }
                                                    </span>
                                                </Dropzone>
                                            </div>
                                        </section>
                                    </Col>
                                    <Col xs={12}>
                                        <div style={{marginLeft: '150px', textAlign: 'center', marginBottom: '15px'}}>
                                            {
                                                this.state.tablicaSkanowDodanych.map(item => {
                                                    if (item.typ.indexOf('image') > -1) {
                                                        return (
                                                            <div className={'podgladUploadu inline'}>
                                                                <img src={'data:image/jpg;base64,' + item.dane}/>
                                                                <div className={'usunZdjecie'} onClick={
                                                                    () => {
                                                                        this.onClickUsunSkanZSerwera(item)
                                                                    }
                                                                }>
                                                                    <i className={'fa fa-trash'}
                                                                       title={'Usuń zdjęcie'}></i>
                                                                </div>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className={'podgladUploaduSkan inline'}>
                                                                <span><i className={'fa fa-paperclip'}></i> {item.nazwa}</span>
                                                                <div className={'usunZdjecie'} onClick={
                                                                    () => {
                                                                        this.onClickUsunSkanZSerwera(item)
                                                                    }
                                                                }>
                                                                    <i className={'fa fa-trash'}
                                                                       title={'Usuń zdjęcie'}></i>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                })
                                            }


                                            {
                                                this.state.tablicaSkanowDoWysylki.map(item => {
                                                    if (item.typ.indexOf('image') > -1) {
                                                        return (
                                                            <div className={'podgladUploadu inline'}>
                                                                <img src={'data:image/jpg;base64,' + item.dane}/>
                                                                <div className={'usunZdjecie'} onClick={
                                                                    () => {
                                                                        this.onClickUsunSkanyZWysylki(item.localid)
                                                                    }
                                                                }>
                                                                    <i className={'fa fa-trash'}
                                                                       title={'Usuń zdjęcie'}></i>
                                                                </div>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className={'podgladUploaduSkan inline'}>
                                                                <span><i className={'fa fa-paperclip'}></i> {item.nazwa}</span>
                                                                <div className={'usunZdjecie'} onClick={
                                                                    () => {
                                                                        this.onClickUsunSkanyZWysylki(item.localid)
                                                                    }
                                                                }>
                                                                    <i className={'fa fa-trash'}
                                                                       title={'Usuń zdjęcie'}></i>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col xs={12} lg={6}>
                                <FormGroup>
                                    <h6>Dane kontakowe</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Telefon <span style={{color: 'dodgerblue'}}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nrTel.length}/15 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputTelefon'} type={'number'}
                                                     onChange={this.onChangeTelefon}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Email <span style={{color: 'dodgerblue'}}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.email.length}/200 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputEmail'} onChange={this.onChangeEmail}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col xs={12} lg={7} lgOffset={3}>
                                        <TopAlertInformacja
                                            text={'Zaleca się podanie telefonu bądź emaila w celu łatwiejszego wyszukiwania klienta'}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <h6>Dane adresowe</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Miejscowość <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.miejscowosc.length}/30 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputMiejscowosc'} onChange={this.onChangeMiejscowosc}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Kod pocztowy <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.kodPoczt.length}/10 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputKodPoczt'} onChange={this.onChangeKodPocztowy}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Ulica <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.ulica.length}/40 znaków</span>
                                        </ControlLabel>
                                        <FormControl id={'inputUlica'} onChange={this.onChangeUlica}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Nr domu / nr mieszkania
                                        </ControlLabel>
                                        <div style={{display: 'inline-block'}}>
                                            <FormControl id={'inputDom'} onChange={this.onChangeNrDomu}
                                                         style={{width: '70px'}}/>
                                            <span style={{margin: '0 3px'}}>/</span>
                                            <FormControl id={'inputMieszkanie'} onChange={this.onChangeNrMieszk}
                                                         style={{width: '70px'}}/>
                                        </div>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <h6>Zdjęcie klienta</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Zdjęcie
                                        </ControlLabel>
                                        <section className={'dropzoneSection'} style={{display: 'inline-block'}}>
                                            <div className="dropzone" style={{
                                                border: '1px dotted #aaa',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                lineHeight: '34px',
                                                padding: '0 10px'
                                            }}>
                                                <Dropzone onDrop={this.onDrop} style={{}} multiple={false}
                                                          disabled={Boolean(this.state.wygraneZdjecie)}>
                                                    <span style={{display: 'inline-block'}}>
                                                        {
                                                            Boolean(this.state.zdjecie) ?
                                                                <span style={{color: 'dodgerblue'}}>
                                                                    <i className={'fa fa-info-circle'}></i> Wybierz ponownie aby zmienić plik
                                                                </span>
                                                                :
                                                                !Boolean(this.state.wygraneZdjecie) ?
                                                                    <span style={{color: 'dodgerblue'}}>
                                                                    <i className={'fa fa-info-circle'}></i> Przeciągnij plik lub kliknij aby wybrać. Dozwolony format: JPG lub JPEG
                                                                </span>
                                                                    :
                                                                    <span style={{color: 'firebrick'}}>
                                                                    <i className={'fa fa-info-circle'}></i> Aby zmienić zdjęcie należy usunąć poprzednie
                                                                </span>

                                                        }
                                                    </span>
                                                </Dropzone>
                                            </div>
                                        </section>
                                        {
                                            Boolean(this.state.wygraneZdjecie) ?
                                                <div className={'podgladUploadu'}>
                                                    <img
                                                        src={'data:image/jpg;base64,' + this.state.wygraneZdjecie.dane}/>
                                                    <div className={'usunZdjecie'} onClick={
                                                        () => this.usunZdjecieProfilowe()
                                                    }>
                                                        <i className={'fa fa-trash'} title={'Usuń zdjęcie'}></i>
                                                    </div>
                                                </div>
                                                :
                                                ''
                                        }
                                        {
                                            Boolean(this.state.zdjecie) ?
                                                <div className={'podgladUploadu'}>
                                                    <img src={'data:image/jpg;base64,' + this.state.zdjecie.dane}/>
                                                    <div className={'usunZdjecie'} onClick={(() => {
                                                        this.setState({zdjecie: null, wygraneZdjecie: null})
                                                    })}>
                                                        <i className={'fa fa-trash'} title={'Usuń zdjęcie'}></i>
                                                    </div>
                                                </div>
                                                :
                                                ''
                                        }
                                        <TopIf isTrue={this.props.nowyPrzezMiesieczny && !Boolean(this.state.zdjecie)}>
                                            <TopAlertOstrzezenie
                                                text={'Dodajesz nowego klienta przez widok miesięczny - uzupełnij zdjęcie'}/>
                                        </TopIf>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col xs={12}>
                                        <div className={'add-label-margin'}></div>
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }} text={'Anuluj'} disabled={this.props.disableAnuluj}/>
                                        <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ValidatorMessages messages={this.state.validatorMessages}/>
                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/klienci/components/KlienciForm.js